'use client';

import React__default, { useState, useMemo } from 'react';
import BottomSheet from '../../BottomSheet/index.js';
import { useMultipleRadioGroupContext } from '../context.js';
import { EmptyPlaceholder } from '../Dropdown/Dropdown.css.js';
import { transformToLatin } from '../../Utils/helpers.js';
import { ScrollableContainer } from '../MobileDialog/MobileDialog.css.js';
import Search from '../Dropdown/Search/index.js';
import { Body, List, ListItem } from './styles.css.js';

function PopupBottom(_a) {
    var onCancel = _a.onCancel, isOpen = _a.isOpen, titleDropDown = _a.titleDropDown;
    var _b = useMultipleRadioGroupContext(), handleChange = _b.handleChange, dropdown = _b.dropdown, options = _b.options, selectedItem = _b.selectedItem;
    var _c = dropdown || {}, _d = _c.emptyText, emptyText = _d === void 0 ? 'No result found' : _d, _e = _c.isSearchable, isSearchable = _e === void 0 ? false : _e, _f = _c.searchBoxPlaceholder, searchBoxPlaceholder = _f === void 0 ? 'Search' : _f, _g = _c.searchFields, searchFields = _g === void 0 ? ['name'] : _g;
    var _h = useState(''), searchText = _h[0], setSearchText = _h[1];
    var handleClickItem = function (value) {
        setTimeout(function () {
            setSearchText('');
        }, 200);
        handleChange(value);
    };
    var handleSetSearchText = function (value) {
        setSearchText(transformToLatin(value));
    };
    var renderOptions = useMemo(function () {
        return options.filter(function (option) {
            if (searchText === '')
                return true;
            var optionSearch = '';
            searchFields.map(function (field) {
                optionSearch += option[field];
            });
            return transformToLatin(optionSearch).indexOf(searchText) > -1;
        });
    }, [searchText, options]);
    return (React__default.createElement(BottomSheet, { onClose: onCancel, isOpen: isOpen, header: titleDropDown, footer: React__default.createElement(React__default.Fragment, null), options: { isReverseHeader: true } },
        React__default.createElement(Body, null,
            isSearchable && (React__default.createElement(Search, { searchText: searchText, placeholder: searchBoxPlaceholder, onChange: handleSetSearchText })),
            React__default.createElement(ScrollableContainer, null,
                React__default.createElement(List, null,
                    renderOptions.map(function (option) {
                        return (React__default.createElement(ListItem, { key: option.id, onClick: function () { return handleClickItem(option); }, active: option.id === (selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.id) }, option.name));
                    }),
                    renderOptions.length === 0 && (React__default.createElement(ListItem, null,
                        React__default.createElement(EmptyPlaceholder, null, emptyText))))))));
}

export { PopupBottom as default };
//# sourceMappingURL=index.js.map
